export default __webpack_public_path__ + "static/media/2-desk.3e2af6f5.jpg";